var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.0023,
    height: 26.0023,
    rx: 13.0011,
    fill: "#db0b27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3342 19.0023C15.2317 19.0013 14.1462 18.7288 13.1739 18.2089L12.8739 18.0422C10.8009 16.9277 9.10133 15.2281 7.98676 13.1551L7.82008 12.8551C7.28657 11.8772 7.00475 10.782 7 9.66808V9.22137C6.99972 8.86597 7.14132 8.52517 7.39337 8.27461L8.52015 7.14784C8.62958 7.03756 8.78405 6.98441 8.93816 7.004C9.09228 7.02358 9.22854 7.1137 9.30689 7.24785L10.807 9.82143C10.9587 10.0834 10.9149 10.4147 10.7004 10.6282L9.44024 11.8883C9.33559 11.9918 9.3112 12.1517 9.38023 12.2817L9.61359 12.7217C10.4517 14.2741 11.7267 15.5468 13.2806 16.3821L13.7206 16.6221C13.8507 16.6911 14.0105 16.6667 14.114 16.5621L15.3741 15.302C15.5876 15.0874 15.9189 15.0436 16.1809 15.1953L18.7545 16.6954C18.8886 16.7738 18.9788 16.9101 18.9983 17.0641C19.0179 17.2183 18.9648 17.3728 18.8545 17.4822L17.7277 18.609C17.4771 18.861 17.1363 19.0026 16.7809 19.0023H16.3342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.9539c7e2ad3685a52c8c2c37c140809f.svg";
export { ForwardRef as ReactComponent };